// extracted by mini-css-extract-plugin
export var divider = "_qc-0";
export var systemMessage = "_qc-1";